import { FBTrackingEvent } from '../FBTrackingEvent';
import { PlayerStateHelper } from '../../../State/Player/PlayerStateHelper';
import Game from '../../../Game';
import { track, sendEvent } from '../Track';
import { BoosterType } from '../../../State/Card/BoosterType';
import { FTUXTrackingEventName } from '../TrackingEvent';
import { IGameState } from '../../../State/Game/IGameState';

export function trackCardPlayed(state: IGameState) {
    try {
        const extraCardsUsed: boolean = state.levelState.boosterUses[BoosterType.PLUS_FIVE] !== 0;
        track('tCardsLeft', extraCardsUsed ? 0 : state.levelState.cardsState.inStack.length);

        if (
            !state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_04_FirstCardClear) &&
            state.levelState.cardsState.turns > 0
        ) {
            state = PlayerStateHelper.addFBTrackingEvent(state, FBTrackingEvent.FTUE_04_FirstCardClear);
            Game.sdk.gameTracking(FBTrackingEvent.FTUE_04_FirstCardClear);

            track('stepId', 4);
            track('stepName', FBTrackingEvent.FTUE_04_FirstCardClear);
            sendEvent(FTUXTrackingEventName.ftux, state);
        }
    } catch (e) {
        console.error('Failed to track', e);
        return state;
    }
    return state;
}
